export const getBoundsByRadius = (center: google.maps.LatLngLiteral, radius: number) => {
  const circle = new google.maps.Circle({
    center,
    radius,
  });
  return circle.getBounds();
};
